import { render, staticRenderFns } from "./BasicDashboardOffers.vue?vue&type=template&id=7f6f4424&lang=true"
import script from "./BasicDashboardOffers.vue?vue&type=script&lang=js"
export * from "./BasicDashboardOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports